<template>

  <div id="gift-card-popup" style="z-index:5" class="pos-fixed" @click.stop.prevent>
    <div class="overlay" style="background: rgba(0, 0, 0, 0.55);" @click.stop.prevent="toggleMileStoneModal(false, model)" v-if="isShowMilestoneModal"></div>
      <div class="bg-light padding-10 pos-fixed pos-center-ver pos-center-hor index-3 radius-3"
           style="width: 7rem; height: 7rem;
                       padding: 1.25rem;
                       text-align: center;
                        z-index: 1000"
      v-if="isShowMilestoneModal">
        <div style="width:100%;height: 100%; display: flex; flex-direction: column; align-content: center; justify-content: center">
          <div style="width: 100%; text-align: center">
            <span>WIN</span>
          </div>
          <div style="display: flex; justify-content: center;align-itemodel: center;padding:10px 0">
            <img src="@/assets/CheckInPopup/Confetti1.svg" class="w40">
            <img src="@/assets/CheckInPopup/Scratch_Card.svg" class="w40">
            <img src="@/assets/CheckInPopup/Confetti2.svg" class="w40">
          </div>
          <div style="white-space: normal" v-if="model.min_price!==model.max_price">
            {{model.min_price}} to {{model.max_price}} {{model.currency_label}}
          </div>
          <div v-else>
            <span v-if="model.currency_label==='Cash'">₹</span> {{model.max_price}} <span v-if="model.currency_label !=='Cash'">{{model.currency_label}}</span>
          </div>

        </div>
      </div>
    </div>
</template>
<script>
import { globals } from "@/mixins/globals"
export default {
  mixins: [globals],
  props: {
    model: Object
  },
  data() {
    return {
      receiverName: '',
      receiverEmail: '',
      refNum: ''
    }
  },
  methods: {
    showContactNumber(name){
      return name.toLowerCase().includes('paytm')
    },
  },
  created() {
    var trans = this.model

  }
}
</script>



// WEBPACK FOOTER //
// src/components/milestone-detail-popup.vue